import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=3c922af5&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c922af5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c922af5')) {
      api.createRecord('3c922af5', component.options)
    } else {
      api.reload('3c922af5', component.options)
    }
    module.hot.accept("./roles.vue?vue&type=template&id=3c922af5&scoped=true&", function () {
      api.rerender('3c922af5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/roles.vue"
export default component.exports